
import { Course } from './types';
import { 
  FORMS_MODULE, 
  STYLING_MODULE, 
  ERROR_HANDLING_MODULE,
  SSR_MODULE,
  ADVANCED_TESTING_MODULE,
  CONCURRENT_FEATURES_MODULE
} from './modules';

export const ADVANCED_COURSE: Course = {
  id: "advanced-react",
  title: "Advanced React Development",
  description: "Master advanced React concepts, patterns, and modern development techniques for building production-ready applications.",
  level: "advanced",
  badge: "🔥 Advanced",
  totalDuration: "12-15 hours",
  duration: "12-15 hours",
  estimatedHours: 13,
  imageSrc: "/images/course-thumbnail.png",
  requirements: [
    "Completion of Intermediate React course or equivalent experience",
    "Strong understanding of React hooks and state management",
    "Experience with modern JavaScript (ES6+) and TypeScript",
    "Familiarity with build tools and development workflows",
    "Basic knowledge of testing concepts"
  ],
  tags: ["React", "Advanced", "Performance", "Testing", "SSR", "Production"],
  learningOutcomes: [
    "Build complex forms with advanced validation and optimization",
    "Master modern styling solutions and design systems",
    "Implement robust error handling and recovery strategies",
    "Set up server-side rendering and static site generation",
    "Write comprehensive tests for React applications",
    "Utilize React 18's concurrent features and performance optimizations",
    "Apply advanced React patterns and architectural principles"
  ],
  modules: [
    FORMS_MODULE,
    STYLING_MODULE,
    ERROR_HANDLING_MODULE,
    SSR_MODULE,
    ADVANCED_TESTING_MODULE,
    CONCURRENT_FEATURES_MODULE
  ],
  finalAssessment: {
    id: "advanced-final",
    title: "Advanced React Mastery Assessment",
    description: "Comprehensive final assessment covering advanced React development concepts, patterns, and best practices",
    questions: [
      {
        id: "q1",
        question: "Which React Hook Form hook is used for managing dynamic form fields?",
        options: ["useFormArray", "useFieldArray", "useDynamicField", "useArrayField"],
        correctAnswer: 1,
        difficulty: "medium"
      },
      {
        id: "q2",
        question: "What is the main benefit of using CSS-in-JS solutions like styled-components?",
        options: ["Smaller bundle size", "Dynamic styling based on props", "Better SEO", "Faster loading"],
        correctAnswer: 1,
        difficulty: "medium"
      },
      {
        id: "q3",
        question: "Which pattern is recommended for error boundaries in React?",
        options: ["Try-catch in components", "Error boundary components", "Global error handlers", "Console logging"],
        correctAnswer: 1,
        difficulty: "easy"
      },
      {
        id: "q4",
        question: "What is the primary advantage of Server-Side Rendering (SSR)?",
        options: ["Reduced server load", "Better SEO and initial load performance", "Simpler deployment", "Lower costs"],
        correctAnswer: 1,
        difficulty: "medium"
      },
      {
        id: "q5",
        question: "Which testing approach is best for testing component behavior?",
        options: ["Unit tests only", "Integration tests only", "End-to-end tests only", "Combination of all three"],
        correctAnswer: 3,
        difficulty: "hard"
      },
      {
        id: "q6",
        question: "What is React 18's Concurrent Mode primarily designed to improve?",
        options: ["Bundle size", "User experience through better rendering", "Development speed", "Memory usage"],
        correctAnswer: 1,
        difficulty: "hard"
      }
    ],
    questionsByDifficulty: {
      easy: [
        {
          id: "easy-1",
          question: "Which pattern is recommended for error boundaries in React?",
          options: ["Try-catch in components", "Error boundary components", "Global error handlers", "Console logging"],
          correctAnswer: 1,
          difficulty: "easy"
        }
      ],
      medium: [
        {
          id: "medium-1",
          question: "Which React Hook Form hook is used for managing dynamic form fields?",
          options: ["useFormArray", "useFieldArray", "useDynamicField", "useArrayField"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        {
          id: "medium-2",
          question: "What is the main benefit of using CSS-in-JS solutions like styled-components?",
          options: ["Smaller bundle size", "Dynamic styling based on props", "Better SEO", "Faster loading"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        {
          id: "medium-3",
          question: "What is the primary advantage of Server-Side Rendering (SSR)?",
          options: ["Reduced server load", "Better SEO and initial load performance", "Simpler deployment", "Lower costs"],
          correctAnswer: 1,
          difficulty: "medium"
        }
      ],
      hard: [
        {
          id: "hard-1",
          question: "Which testing approach is best for testing component behavior?",
          options: ["Unit tests only", "Integration tests only", "End-to-end tests only", "Combination of all three"],
          correctAnswer: 3,
          difficulty: "hard"
        },
        {
          id: "hard-2",
          question: "What is React 18's Concurrent Mode primarily designed to improve?",
          options: ["Bundle size", "User experience through better rendering", "Development speed", "Memory usage"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      ]
    }
  },
  certificateTemplate: "advanced-react"
};
